<template>
  <BaseDialog
    centered
    contentClass="missing-required-seao-role"
    ref="dialog"
    :show-actions="true"
    @closeModal="closeDialog"
  >
    <template slot="title">{{ $t('aloha-extension.missing-required-seao-role.title') }}</template>
    <template slot="content">
      <div class="missing-required-seao-role-dialog">
        <div class="missing-required-seao-role-dialog__section">
          <BaseIcon name="alert-circle" class="missing-required-seao-role-dialog__icon is-error" />
          <p
            class="missing-required-seao-role-dialog__description"
            v-html="$t('aloha-extension.missing-required-seao-role.description')"
          ></p>
        </div>
      </div>
    </template>
    <template slot="actions">
      <div class="missing-required-seao-role-dialog__actions">
        <BaseButton @click.native="closeDialog">{{ $t('actions.close') }}</BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'MissingRequiredSeaoRoleDialog',
  components: {
    BaseButton,
    BaseDialog,
    BaseIcon,
  },
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__missing-required-seao-role {
  height: auto;
  max-height: 80vh !important;
  width: 50%;
  min-width: 400px;
  max-width: 600px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    padding: 0;
  }

  .base-dialog__actions {
    padding: 16px 32px;
    background: transparent;
  }
}

.missing-required-seao-role-dialog {
  padding: 0 32px 16px;

  &__section {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 0;
  }

  &__icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 2px;

    &.is-error {
      color: $color-error;
    }
  }

  &__description {
    font-size: $font-size-small;
    color: $color-normal;
    margin: 0;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
